import { T, useGT } from 'gt-react';
import { ChatDotsIcon } from '@phosphor-icons/react';
import { SidebarMenuButton } from '@/components/ui/sidebar';
import { HELP_MENU_ORDER, HelpMenuSlot } from '@/components/common/HelpMenu';
import { useHotkeyLabel } from '@/hooks/useHotkeyLabel';
import { HOTKEY_IDS } from '@/lib/hotkeys/registry';

/** The sidebar Help-menu "Send feedback" entry, shared by both flag paths. */
export function SendFeedbackMenuButton({
  onClick,
  disabled,
}: {
  onClick: () => void;
  disabled?: boolean;
}) {
  const gt = useGT();
  const { label: shortcutLabel } = useHotkeyLabel(HOTKEY_IDS.feedback);
  return (
    <HelpMenuSlot order={HELP_MENU_ORDER.feedback}>
      <SidebarMenuButton
        onClick={onClick}
        disabled={disabled}
        className="cursor-pointer"
        aria-label={gt('Send feedback', {
          context: 'sidebar help menu button aria label for feedback',
        })}
        tooltip={gt('Send feedback ({shortcut})', {
          context:
            'tooltip on the collapsed sidebar Send feedback menu item, includes keyboard shortcut',
          shortcut: shortcutLabel,
        })}
      >
        <ChatDotsIcon />
        {/* Trailing label/shortcut block — hidden in icon-mode so the
            SidebarMenuButton can center the icon inside its 32×32 shell. */}
        <span className="flex w-full items-center justify-between gap-2 group-data-[collapsible=icon]:hidden">
          <T context="sidebar help menu item label for sending feedback">
            Send feedback
          </T>
          <kbd className="rounded border border-sidebar-border/60 bg-sidebar-accent/40 px-1.5 py-0.5 font-mono text-[10px] text-muted-foreground">
            {shortcutLabel}
          </kbd>
        </span>
      </SidebarMenuButton>
    </HelpMenuSlot>
  );
}
